import React from "react";
import { useNavigate } from "react-router-dom";

import { GoodsItemType } from "../../../../types/goods";

import { ServiceRentalState } from "../../../../pages/Services/Rental";
import { HistoryReservationLocationIcon } from "../../../History/ReservationItem";
import ServiceRentItemImage from "../ItemImage";

type Props = { goods: GoodsItemType; state?: ServiceRentalState };

export default function ServiceRentListItem({ goods, state }: Props) {
  const navigate = useNavigate();

  return (
    <div
      key={goods.stockId}
      className="p-5 rounded-[10px] flex gap-2.5 self-stretch"
      style={{
        boxShadow: "0px 1px 5px 0px rgba(0, 0, 0, 0.08)",
      }}
      onClick={() => navigate(goods.stockId, { state })}
    >
      <ServiceRentItemImage
        src={goods.goodsImg?.items.find((item) => item.scale === "small")?.url}
        name={goods.goodsName}
      />
      <div className="flex flex-col gap-2.5 flex-[1_0_0]">
        <div className="flex flex-col justify-center gap-1 self-stretch">
          <div className="bg-brand-primary-magenta rounded-full flex px-2 py-px justify-center items-center gap-2.5 text-white text-xs font-semibold leading-4 w-fit">
            {goods?.activityCount ?? 0}개 보유
          </div>
          <div className="h-[22px] self-stretch truncate text-justify text-[15px] font-medium leading-[22px]  max-w-[calc(100vw-180px)]">
            {goods.goodsName}
          </div>
        </div>
        <div className="h-[31px] flex-[1_0_0] truncate text-brand-neutral-40 text-justify text-xs leading-4 tracking-[-0.12px] max-w-[calc(100vw-170px)]">
          {goods.goodsDescription}
        </div>
        <div className="flex gap-1 text-sm leading-4 text-brand-neutral-80">
          <HistoryReservationLocationIcon /> {goods.buildingName}{" "}
          {goods.floorName} {goods.storeName}
        </div>
      </div>
    </div>
  );
}
